export default function normalizeResolution(resolution) {
  return resolution.trim().replaceAll(/\s+/g, " ");
}